module.exports = __webpack_public_path__ + "img/Our_work_6.d6c95283.png";